// extracted by mini-css-extract-plugin
module.exports = {"trash-button":"trash-button___1kKN-","icon":"icon___1innh"};